import axios from "axios";

const hostname = 
  // "http://localhost:5000";
  "https://api.exorehab.com";

export async function GET(uri, headers) {
  const res = await axios.get(hostname + uri, { headers });
  return res.data;
}

export async function POST(uri, data, headers) {
  const res = await axios.post(hostname + uri, data, { headers });
  return res.data;
}

export async function DELETE(uri, headers) {
  const res = await axios.delete(hostname + uri, { headers });
  return res.data;
}

export default {
  GET, POST, DELETE
}